/**
 * Detect user activity events and broadcast them cross-tab.
 * Throttled: emits at most once per second locally.
 */

import { broadcast } from "./broadcastChannel";

const ACTIVITY_EVENTS = [
  "keydown",
  "mousedown",
  "mousemove",
  "touchstart",
  "scroll",
  "visibilitychange",
] as const;

let lastEmit = 0;
let cleanup: (() => void) | null = null;

export function startActivityDetector(onActivity: () => void): () => void {
  function emit() {
    const now = Date.now();
    if (now - lastEmit < 1000) return; // throttle: 1 per second
    lastEmit = now;
    broadcast({ type: "active", ts: now });
    onActivity();
  }

  const handle = () => emit();

  for (const event of ACTIVITY_EVENTS) {
    window.addEventListener(event, handle, { passive: true });
  }

  cleanup = () => {
    for (const event of ACTIVITY_EVENTS) {
      window.removeEventListener(event, handle);
    }
  };

  return cleanup;
}

export function stopActivityDetector(): void {
  cleanup?.();
  cleanup = null;
}
